import logo from "../../../assets/Rectangle.png";
import logo2 from "../../../assets/image 12.png";
import logo3 from "../../../assets/image 14.png";
import pic1 from "../../../assets/Ellipse 10.svg";
import pic2 from "../../../assets/Ellipse 11.svg";
import pic3 from "../../../assets/Ellipse 9.svg";
import Image from "next/image";

const CarouselOne = () => {
  return (
    <div className="carousel w-full dark:text-white pb-10 md:pb-0 ">
      <div
        id="slide1"
        className="carousel-item relative w-full  py-14 md:py-40 "
      >
        <div className="md:grid md:grid-cols-2 px-2 md:px-14 ">
          <div>
            <p className="text-5xl lg:text-6xl font-bold text-blue-600 pt-5 ">
              Ready to enjoy the most popular
              <span className="flex">
                p
                <svg
                  className="mt-3 lg:mt-4"
                  xmlns="http://www.w3.org/2000/svg"
                  width="51"
                  height="51"
                  viewBox="0 0 51 51"
                  fill="none"
                >
                  <path
                    d="M40.6298 19.38C39.8011 19.38 39.1423 20.0388 39.1423 20.8675V24.225C39.1423 31.7475 33.0223 37.8675 25.4998 37.8675C17.9773 37.8675 11.8573 31.7475 11.8573 24.225V20.8463C11.8573 20.0175 11.1986 19.3588 10.3698 19.3588C9.54107 19.3588 8.88232 20.0175 8.88232 20.8463V24.2038C8.88232 32.8525 15.5336 39.9713 24.0123 40.7363V45.2625C24.0123 46.0913 24.6711 46.75 25.4998 46.75C26.3286 46.75 26.9873 46.0913 26.9873 45.2625V40.7363C35.4448 39.9925 42.1173 32.8525 42.1173 24.2038V20.8463C42.108 20.4567 41.9476 20.0859 41.6701 19.8124C41.3925 19.5388 41.0195 19.3838 40.6298 19.38Z"
                    fill="url(#paint0_linear_2_5125)"
                  />
                  <path
                    d="M25.4955 4.25C20.3105 4.25 16.103 8.4575 16.103 13.6425V24.5225C16.103 29.7075 20.3105 33.915 25.4955 33.915C30.6805 33.915 34.888 29.7075 34.888 24.5225V13.6425C34.888 8.4575 30.6805 4.25 25.4955 4.25ZM28.2793 19.0187C28.1305 19.5712 27.6418 19.9325 27.0893 19.9325C26.983 19.9325 26.8768 19.9112 26.7705 19.89C25.9418 19.6562 25.0705 19.6562 24.2418 19.89C23.5618 20.0812 22.903 19.6775 22.733 19.0187C22.5418 18.36 22.9455 17.68 23.6043 17.51C24.858 17.17 26.1755 17.17 27.4293 17.51C28.0668 17.68 28.4493 18.36 28.2793 19.0187ZM29.4055 14.8963C29.3178 15.135 29.1584 15.3408 28.9492 15.4853C28.7399 15.6299 28.4911 15.7062 28.2368 15.7037C28.088 15.7037 27.9605 15.6825 27.8118 15.64C26.3243 15.0875 24.6668 15.0875 23.1793 15.64C22.8692 15.75 22.5283 15.7336 22.2301 15.5945C21.932 15.4553 21.7005 15.2045 21.5855 14.8963C21.3518 14.2588 21.6918 13.5363 22.3293 13.3237C24.3746 12.58 26.6165 12.58 28.6618 13.3237C29.2993 13.5575 29.6393 14.2588 29.4055 14.8963Z"
                    fill="url(#paint1_linear_2_5125)"
                  />
                  <defs>
                    <linearGradient
                      id="paint0_linear_2_5125"
                      x1="5.84643"
                      y1="23.6196"
                      x2="51.2982"
                      y2="29.673"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stopColor="#FF9447" />
                      <stop offset="0.358383" stopColor="#FF64C1" />
                      <stop offset="0.65524" stopColor="#925EFF" />
                      <stop offset="1" stopColor="#1A1EFF" />
                    </linearGradient>
                    <linearGradient
                      id="paint1_linear_2_5125"
                      x1="14.3871"
                      y1="8.86456"
                      x2="40.4072"
                      y2="10.6731"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stopColor="#FF9447" />
                      <stop offset="0.358383" stopColor="#FF64C1" />
                      <stop offset="0.65524" stopColor="#925EFF" />
                      <stop offset="1" stopColor="#1A1EFF" />
                    </linearGradient>
                  </defs>
                </svg>
                dcast
              </span>
            </p>

            <div className="relative">
              <p className="mt-6 md:w-3/4">
                Discovered latest top-notch stories from world wide community,
                quality informative podcast and verified creators.
              </p>

              <div className="absolute z-10 right-0 md:-right-32 lg:-right-20 top-20 md:top-0 w-56 h-28  px-3 py-4 rounded-3xl bg-gray-200 filter blur-10 opacity-90">
                <p className="text-blue-600 text-base font-extrabold pb-2">
                  Enjoy The Nature
                </p>

                <svg
                  className=""
                  xmlns="http://www.w3.org/2000/svg"
                  width="192"
                  height="10"
                  viewBox="0 0 192 10"
                  fill="none"
                >
                  <rect
                    x="0.286621"
                    y="0.190308"
                    width="190.932"
                    height="9.5466"
                    rx="4.7733"
                    fill="#949494"
                  />
                  <rect
                    x="0.286621"
                    y="0.190308"
                    width="99.046"
                    height="9.5466"
                    rx="4.7733"
                    fill="#4285F4"
                  />
                </svg>

                <div className="flex justify-center gap-4 items-center mt-2">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="11"
                    height="12"
                    viewBox="0 0 11 12"
                    fill="none"
                  >
                    <path
                      d="M9.33496 4.05747V8.21913C9.33496 9.07146 8.4087 9.60635 7.66943 9.18018L5.86474 8.14085L4.06005 7.09717C3.32078 6.67101 3.32078 5.60559 4.06005 5.17942L5.86474 4.13574L7.66943 3.09642C8.4087 2.67025 9.33496 3.20078 9.33496 4.05747ZM2.16838 8.82359V3.44866V8.82359Z"
                      fill="#4285F4"
                    />
                    <path
                      d="M2.16838 8.82359V3.44866M9.33496 4.05747V8.21913C9.33496 9.07146 8.4087 9.60635 7.66943 9.18018L5.86474 8.14085L4.06005 7.09717C3.32078 6.67101 3.32078 5.60559 4.06005 5.17942L5.86474 4.13574L7.66943 3.09642C8.4087 2.67025 9.33496 3.20078 9.33496 4.05747V4.05747Z"
                      stroke="#4285F4"
                      strokeWidth="0.694541"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>

                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="27"
                    height="27"
                    viewBox="0 0 27 27"
                    fill="none"
                  >
                    <circle
                      cx="13.7125"
                      cy="13.136"
                      r="13.046"
                      fill="#4285F4"
                    />
                    <path
                      d="M9.36328 8.80995V7.00921C9.36328 4.76637 10.9598 3.84983 12.9147 4.97125L14.4895 5.87701L16.0643 6.78277C18.0192 7.90419 18.0192 9.73728 16.0643 10.8587L14.4895 11.7645L12.9147 12.6702C10.9598 13.7916 9.36328 12.8751 9.36328 10.6323V8.80995Z"
                      fill="#505050"
                    />
                  </svg>

                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="11"
                    height="12"
                    viewBox="0 0 11 12"
                    fill="none"
                  >
                    <path
                      d="M2.09131 4.05747V8.21913C2.09131 9.07146 3.01757 9.60635 3.75684 9.18018L5.56153 8.14085L7.36622 7.09717C8.10549 6.67101 8.10549 5.60559 7.36622 5.17942L5.56153 4.13574L3.75684 3.09642C3.01757 2.67025 2.09131 3.20078 2.09131 4.05747ZM9.25788 8.82359V3.44866V8.82359Z"
                      fill="#4285F4"
                    />
                    <path
                      d="M9.25789 8.82359V3.44866M2.09131 4.05747V8.21913C2.09131 9.07146 3.01757 9.60635 3.75684 9.18018L5.56153 8.14085L7.36622 7.09717C8.10549 6.67101 8.10549 5.60559 7.36622 5.17942L5.56153 4.13574L3.75684 3.09642C3.01757 2.67025 2.09131 3.20078 2.09131 4.05747V4.05747Z"
                      stroke="#4285F4"
                      strokeWidth="0.694541"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
              </div>
            </div>

            <button
              onClick={() => router.push("/podcast")}
              className="text-white text-lg font-semibold px-14 py-5 mb-10 md:mb-0 mt-36 md:mt-10 bg-gradient-to-br  from-blue-900 via-blue-700 to-blue-400  rounded-[50px]"
            >
              Browse Podcast
            </button>
          </div>

          <div className="relative mt-10 md:mt-0 ">
            <Image
              className="w-1/2 mx-auto md:ml-0 md:w-[375px] md:h-[504px]"
              src={logo ? logo : "/"}
              alt="logo"
            />

            <div className="absolute top-2 md:-top-10 md:-left-32 w-[83px] h-8 md:w-44 md:h-[70px] bg-blue-700 rounded-[141px]">
              <div className="flex items-center ml-2">
                <Image
                  className="w-1/3 md:w-[55px] py-1 md:py-[7px]"
                  src={pic1 ? pic1 : "/"}
                  alt="logo"
                />
                <Image
                  className="w-1/3 md:w-[55px] py-1 md:py-[7px] absolute left-7 md:left-10"
                  src={pic2 ? pic2 : "/"}
                  alt="logo"
                />

                <div className="absolute hidden md:block right-2 bg-black p-3 rounded-full">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="35"
                    height="35"
                    viewBox="0 0 35 35"
                    fill="none"
                  >
                    <path
                      d="M34.0243 15.1178L31.6876 12.4234C31.2409 11.9118 30.8801 10.9568 30.8801 10.2747V7.37572C30.8801 5.56811 29.3853 4.08451 27.5641 4.08451H24.6433C23.9732 4.08451 22.9939 3.7264 22.4785 3.28302L19.7638 0.963821C18.5783 -0.0423022 16.6368 -0.0423022 15.4341 0.963821L12.7367 3.30007C12.2212 3.7264 11.2419 4.08451 10.5718 4.08451H7.59946C5.77824 4.08451 4.28347 5.56811 4.28347 7.37572V10.2918C4.28347 10.9568 3.92266 11.9118 3.49313 12.4234L1.17366 15.1348C0.177141 16.3115 0.177141 18.2214 1.17366 19.398L3.49313 22.1095C3.92266 22.621 4.28347 23.576 4.28347 24.2411V27.1571C4.28347 28.9647 5.77824 30.4483 7.59946 30.4483H10.5718C11.2419 30.4483 12.2212 30.8065 12.7367 31.2498L15.4513 33.569C16.6368 34.5752 18.5783 34.5752 19.781 33.569L22.4956 31.2498C23.0111 30.8065 23.9732 30.4483 24.6605 30.4483H27.5813C29.4025 30.4483 30.8973 28.9647 30.8973 27.1571V24.2581C30.8973 23.5931 31.2581 22.621 31.7048 22.1095L34.0415 19.4151C35.038 18.2384 35.038 16.2944 34.0243 15.1178ZM24.7464 14.0434L16.4478 22.28C16.2062 22.5195 15.8787 22.654 15.5372 22.654C15.1957 22.654 14.8682 22.5195 14.6266 22.28L10.4687 18.1532C10.2291 17.9125 10.0947 17.5878 10.0947 17.2494C10.0947 16.911 10.2291 16.5862 10.4687 16.3456C10.967 15.851 11.7917 15.851 12.29 16.3456L15.5372 19.5686L22.9252 12.2358C23.4234 11.7413 24.2481 11.7413 24.7464 12.2358C25.2446 12.7303 25.2446 13.5489 24.7464 14.0434Z"
                      fill="#4285F4"
                    />
                  </svg>
                </div>
              </div>
            </div>

            <p className="text-gray-400 dark:text-blue-600 absolute -top-10 left-40 md:-top-24 md:left-20 text-3xl md:text-8xl font-extrabold ">
              softex
            </p>

            <div className="absolute -top-10 right-6 w-8 h-8 md:w-16 md:h-16 rounded-full bg-gradient-to-br from-blue-800 to-blue-300 -z-10"></div>

            <svg
              className="absolute top-28 md:-right-10 lg:right-20"
              xmlns="http://www.w3.org/2000/svg"
              width="221"
              height="94"
              viewBox="0 0 221 94"
              fill="none"
            >
              <g filter="url(#filter0_b_2_6004)">
                <rect
                  x="0.554688"
                  y="0.979492"
                  width="219.815"
                  height="92.7543"
                  rx="12.7061"
                  fill="#838383"
                  fillOpacity="0.2"
                />
              </g>
              <line
                opacity="0.5"
                x1="10.084"
                y1="46.086"
                x2="209.569"
                y2="46.086"
                stroke="#ADADAD"
                strokeWidth="1.27061"
                strokeLinecap="round"
              />
              <defs>
                <filter
                  id="filter0_b_2_6004"
                  x="-50.2696"
                  y="-49.8448"
                  width="321.464"
                  height="194.403"
                  filterUnits="userSpaceOnUse"
                  colorInterpolationFilters="sRGB"
                >
                  <feFlood floodOpacity="0" result="BackgroundImageFix" />
                  <feGaussianBlur
                    in="BackgroundImageFix"
                    stdDeviation="25.4121"
                  />
                  <feComposite
                    in2="SourceAlpha"
                    operator="in"
                    result="effect1_backgroundBlur_2_6004"
                  />
                  <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_backgroundBlur_2_6004"
                    result="shape"
                  />
                </filter>
              </defs>
            </svg>

            <svg
              className="absolute top-[100px] left-[310px] md:-right-2 lg:left-[435px] z-40"
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M7.70096 1.99658H5.82148C4.78726 1.99658 3.85249 2.41425 3.16633 3.10041C2.48016 3.78657 2.0625 4.72134 2.0625 5.75556C2.0625 7.82399 3.75304 9.51454 5.82148 9.51454H6.75625V17.0225C6.75625 17.7485 7.17391 18.375 7.78052 18.6833C8.00668 18.8081 8.25752 18.8817 8.51528 18.8989C8.77305 18.9161 9.03144 18.8764 9.27217 18.7827C9.99811 18.5241 10.5152 17.838 10.5152 17.0225V4.81084C10.5152 3.26946 9.24234 1.99658 7.70096 1.99658ZM5.82148 5.9445C6.22919 5.9445 6.5673 6.28261 6.5673 6.69033C6.5673 7.09805 6.22919 7.43616 5.82148 7.43616C4.89665 7.43616 4.14088 6.68039 4.14088 5.74562C4.14088 4.81084 4.89665 4.06502 5.82148 4.06502C6.22919 4.06502 6.5673 4.40312 6.5673 4.81084C6.5673 5.21856 6.22919 5.55667 5.82148 5.55667C5.77136 5.55667 5.72331 5.57658 5.68787 5.61201C5.65244 5.64745 5.63253 5.6955 5.63253 5.74562C5.63253 5.84506 5.71209 5.9445 5.82148 5.9445ZM20.8474 3.10041C20.4997 2.75012 20.0861 2.47222 19.6303 2.28275C19.1746 2.09329 18.6858 1.99603 18.1923 1.99658H16.3128C15.5672 1.99921 14.8529 2.29655 14.3257 2.82376C13.7985 3.35097 13.5012 4.06526 13.4985 4.81084V17.0225C13.4985 17.838 14.0156 18.5241 14.7416 18.7827C14.9823 18.8764 15.2407 18.9161 15.4985 18.8989C15.7562 18.8817 16.0071 18.8081 16.2332 18.6833C16.8398 18.375 17.2575 17.7485 17.2575 17.0225V9.51454H18.1923C20.2607 9.51454 21.9513 7.82399 21.9513 5.75556C21.9513 4.72134 21.5336 3.78657 20.8474 3.10041ZM18.1923 7.43616C17.7846 7.43616 17.4465 7.09805 17.4465 6.69033C17.4465 6.28261 17.7846 5.9445 18.1923 5.9445C18.3017 5.9445 18.3812 5.855 18.3812 5.74562C18.3812 5.6955 18.3613 5.64745 18.3259 5.61201C18.2905 5.57658 18.2424 5.55667 18.1923 5.55667C17.7846 5.55667 17.4465 5.21856 17.4465 4.81084C17.4465 4.40312 17.7846 4.06502 18.1923 4.06502C18.6393 4.06502 19.0681 4.2426 19.3842 4.55871C19.7003 4.87481 19.8779 5.30355 19.8779 5.75059C19.8779 6.19763 19.7003 6.62636 19.3842 6.94247C19.0681 7.25857 18.6393 7.43616 18.1923 7.43616Z"
                fill="white"
              />
              <path
                d="M9.27193 18.7836V21.8863C9.27193 22.294 8.93382 22.6321 8.5261 22.6321C8.11838 22.6321 7.78027 22.294 7.78027 21.8863V18.6842C8.00642 18.8091 8.25726 18.8828 8.51503 18.9C8.77281 18.9171 9.03121 18.8774 9.27193 18.7836ZM16.233 18.6842V21.8863C16.233 22.294 15.8949 22.6321 15.4872 22.6321C15.0794 22.6321 14.7413 22.294 14.7413 21.8863V18.7836C14.9821 18.8774 15.2405 18.9171 15.4982 18.9C15.756 18.8828 16.0069 18.8091 16.233 18.6842Z"
                fill="white"
              />
            </svg>

            <svg
              className="absolute top-24 md:-right-5 lg:right-28"
              xmlns="http://www.w3.org/2000/svg"
              width="175"
              height="83"
              viewBox="0 0 175 83"
              fill="none"
            >
              <ellipse
                cx="7.8079"
                cy="37.4903"
                rx="7.15995"
                ry="7.10868"
                fill="#4285F4"
              />
              <rect
                x="20.9346"
                y="32.7512"
                width="45.3464"
                height="3.55434"
                rx="1.77717"
                fill="#4285F4"
              />
              <rect
                x="20.9346"
                y="39.8597"
                width="82.3395"
                height="3.55434"
                rx="1.77717"
                fill="#4285F4"
              />
              <rect
                x="134.3"
                y="0.762085"
                width="33.4131"
                height="31.9891"
                rx="6.35303"
                fill="#4285F4"
              />
              <rect
                x="22.1279"
                y="80.1423"
                width="152.746"
                height="2.36956"
                rx="1.18478"
                fill="#7E7E7E"
              />
              <rect
                x="22.1279"
                y="80.1423"
                width="45.3464"
                height="2.36956"
                rx="1.18478"
                fill="#4285F4"
              />
            </svg>

            <div className="absolute bottom-1 md:bottom-16 lg:-bottom-5 right-10 md:right-20 w-[93px] h-[33px] md:w-[195px] md:h-[74px] bg-blue-700 rounded-[141px]">
              <div className="flex items-center gap-2 md:gap-3 ml-1 md:ml-2">
                <Image
                  className="w-1/3 md:w-[58px] py-[2px] md:py-[7px]"
                  src={pic3 ? pic3 : "/"}
                  alt="logo"
                />

                <div>
                  <p className="w-[43px] h-[4px] md:w-[90px]  md:h-[10px] rounded-[28px] bg-white"></p>
                  <p className="w-[27px] h-[3px] md:w-[58px]  md:h-[7px] rounded-[28px] mt-2 bg-gray-400"></p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="absolute hidden md:block  md:flex justify-between transform -translate-y-1/2 left-1 right-1 top-1/2">
          <a href="#slide4" className="cursor-pointer">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="29"
              height="50"
              viewBox="0 0 29 50"
              fill="none"
            >
              <g clipPath="url(#clip0_2_5119)">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M27.466 0.729992C26.9558 0.260997 26.279 -0.000488281 25.5754 -0.000488281C24.8717 -0.000488281 24.195 0.260997 23.6847 0.729992L1.56792 21.39C1.07285 21.8454 0.678636 22.3935 0.409262 23.001C0.139887 23.6085 0.000976563 24.2627 0.000976562 24.9237C0.000976563 25.5848 0.139887 26.239 0.409262 26.8465C0.678636 27.454 1.07285 28.0021 1.56792 28.4575L23.8449 49.27C24.878 50.2325 26.5517 50.245 27.6003 49.295C27.8542 49.0687 28.0573 48.7942 28.197 48.4888C28.3367 48.1833 28.4101 47.8532 28.4125 47.5192C28.4149 47.1851 28.3464 46.8541 28.2111 46.5468C28.0758 46.2394 27.8767 45.9622 27.6261 45.7325L7.23983 26.69C6.99209 26.4623 6.79481 26.1881 6.66 25.8843C6.52519 25.5804 6.45567 25.2532 6.45567 24.9225C6.45567 24.5918 6.52519 24.2646 6.66 23.9607C6.79481 23.6568 6.99209 23.3827 7.23983 23.155L27.4634 4.26249C27.7111 4.03499 27.9083 3.76107 28.0431 3.45742C28.1779 3.15376 28.2474 2.82673 28.2474 2.49624C28.2474 2.16575 28.1779 1.83872 28.0431 1.53506C27.9083 1.23141 27.7111 0.957492 27.4634 0.729992"
                  fill="url(#paint0_linear_2_5119)"
                />
              </g>
              <defs>
                <linearGradient
                  id="paint0_linear_2_5119"
                  x1="14.2068"
                  y1="-0.000488281"
                  x2="14.2068"
                  y2="49.9997"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#7A95CF" />
                  <stop offset="1" stopColor="#234794" />
                </linearGradient>
                <clipPath id="clip0_2_5119">
                  <rect width="28.4112" height="50" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </a>
          <a href="#slide2" className="cursor-pointer">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="29"
              height="50"
              viewBox="0 0 29 50"
              fill="none"
            >
              <g clipPath="url(#clip0_2_5117)">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M1.53406 49.2701C2.58011 50.2451 4.27187 50.2451 5.31533 49.2701L27.4321 28.6101C27.9272 28.1546 28.3214 27.6065 28.5908 26.999C28.8602 26.3916 28.9991 25.7374 28.9991 25.0763C28.9991 24.4152 28.8602 23.761 28.5908 23.1536C28.3214 22.5461 27.9272 21.998 27.4321 21.5426L5.1552 0.730051C4.64961 0.26492 3.98009 0.0034855 3.28258 -0.00115778C2.58508 -0.00580107 1.9119 0.246695 1.39975 0.705051C1.14605 0.931402 0.943048 1.20576 0.803328 1.51112C0.663607 1.81649 0.590141 2.14637 0.587477 2.48034C0.584814 2.8143 0.653011 3.14524 0.787844 3.45266C0.922677 3.76008 1.12128 4.03744 1.37134 4.26755L21.7602 23.3101C22.008 23.5378 22.2053 23.8119 22.3401 24.1158C22.4749 24.4196 22.5444 24.7469 22.5444 25.0776C22.5444 25.4082 22.4749 25.7355 22.3401 26.0393C22.2053 26.3432 22.008 26.6173 21.7602 26.8451L1.53406 45.7376C1.28639 45.9651 1.08916 46.239 0.954386 46.5426C0.819607 46.8463 0.750101 47.1733 0.750101 47.5038C0.750101 47.8343 0.819607 48.1613 0.954386 48.465C1.08916 48.7686 1.28639 49.0426 1.53406 49.2701Z"
                  fill="url(#paint0_linear_2_5117)"
                />
              </g>
              <defs>
                <linearGradient
                  id="paint0_linear_2_5117"
                  x1="14.7932"
                  y1="-0.0012207"
                  x2="14.7932"
                  y2="50.0013"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#7A95CF" />
                  <stop offset="1" stopColor="#234794" />
                </linearGradient>
                <clipPath id="clip0_2_5117">
                  <rect x="0.588867" width="28.4112" height="50" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </a>
        </div>

        <div className="absolute -bottom-10 md:bottom-16 right-14 flex gap-5 ">
          <a
            href="#slide1"
            className="w-16 h-3 border-2 border-blue-800 bg-blue-800"
          ></a>
          <a href="#slide2" className="w-16 h-3 border-2 border-blue-800"></a>
          <a href="#slide3" className="w-16 h-3 border-2 border-blue-800"></a>
          <a href="#slide4" className="w-16 h-3 border-2 border-blue-800"></a>
        </div>
      </div>

      <div
        id="slide2"
        className="carousel-item relative w-full   py-14 md:py-40 "
      >
        <div className="md:grid md:grid-cols-2 px-2 md:px-14 ">
          <div>
            <p className="text-5xl lg:text-6xl font-bold text-blue-600 pt-5 ">
              Excited to listen to the trendiest podcast out there
            </p>

            <div className="relative">
              <p className="mt-6 md:w-3/4">
                Discovered latest top-notch stories from world wide community,
                quality informative podcast and verified creators.
              </p>

              <div className="absolute z-10 right-0 md:-right-32 lg:-right-20 top-20 md:top-0 w-56 h-28  px-3 py-4 rounded-3xl bg-gray-200 filter blur-10 opacity-90">
                <p className="text-blue-600 text-base font-extrabold pb-2">
                  Enjoy The Nature
                </p>

                <svg
                  className=""
                  xmlns="http://www.w3.org/2000/svg"
                  width="192"
                  height="10"
                  viewBox="0 0 192 10"
                  fill="none"
                >
                  <rect
                    x="0.286621"
                    y="0.190308"
                    width="190.932"
                    height="9.5466"
                    rx="4.7733"
                    fill="#949494"
                  />
                  <rect
                    x="0.286621"
                    y="0.190308"
                    width="99.046"
                    height="9.5466"
                    rx="4.7733"
                    fill="#4285F4"
                  />
                </svg>

                <div className="flex justify-center gap-4 items-center mt-2">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="11"
                    height="12"
                    viewBox="0 0 11 12"
                    fill="none"
                  >
                    <path
                      d="M9.33496 4.05747V8.21913C9.33496 9.07146 8.4087 9.60635 7.66943 9.18018L5.86474 8.14085L4.06005 7.09717C3.32078 6.67101 3.32078 5.60559 4.06005 5.17942L5.86474 4.13574L7.66943 3.09642C8.4087 2.67025 9.33496 3.20078 9.33496 4.05747ZM2.16838 8.82359V3.44866V8.82359Z"
                      fill="#4285F4"
                    />
                    <path
                      d="M2.16838 8.82359V3.44866M9.33496 4.05747V8.21913C9.33496 9.07146 8.4087 9.60635 7.66943 9.18018L5.86474 8.14085L4.06005 7.09717C3.32078 6.67101 3.32078 5.60559 4.06005 5.17942L5.86474 4.13574L7.66943 3.09642C8.4087 2.67025 9.33496 3.20078 9.33496 4.05747V4.05747Z"
                      stroke="#4285F4"
                      strokeWidth="0.694541"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>

                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="27"
                    height="27"
                    viewBox="0 0 27 27"
                    fill="none"
                  >
                    <circle
                      cx="13.7125"
                      cy="13.136"
                      r="13.046"
                      fill="#4285F4"
                    />
                    <path
                      d="M9.36328 8.80995V7.00921C9.36328 4.76637 10.9598 3.84983 12.9147 4.97125L14.4895 5.87701L16.0643 6.78277C18.0192 7.90419 18.0192 9.73728 16.0643 10.8587L14.4895 11.7645L12.9147 12.6702C10.9598 13.7916 9.36328 12.8751 9.36328 10.6323V8.80995Z"
                      fill="#505050"
                    />
                  </svg>

                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="11"
                    height="12"
                    viewBox="0 0 11 12"
                    fill="none"
                  >
                    <path
                      d="M2.09131 4.05747V8.21913C2.09131 9.07146 3.01757 9.60635 3.75684 9.18018L5.56153 8.14085L7.36622 7.09717C8.10549 6.67101 8.10549 5.60559 7.36622 5.17942L5.56153 4.13574L3.75684 3.09642C3.01757 2.67025 2.09131 3.20078 2.09131 4.05747ZM9.25788 8.82359V3.44866V8.82359Z"
                      fill="#4285F4"
                    />
                    <path
                      d="M9.25789 8.82359V3.44866M2.09131 4.05747V8.21913C2.09131 9.07146 3.01757 9.60635 3.75684 9.18018L5.56153 8.14085L7.36622 7.09717C8.10549 6.67101 8.10549 5.60559 7.36622 5.17942L5.56153 4.13574L3.75684 3.09642C3.01757 2.67025 2.09131 3.20078 2.09131 4.05747V4.05747Z"
                      stroke="#4285F4"
                      strokeWidth="0.694541"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
              </div>
            </div>

            <button
              onClick={() => router.push("/podcast")}
              className="text-white text-lg font-semibold px-14 py-5 mb-10 md:mb-0 mt-36 md:mt-10 bg-gradient-to-br  from-blue-900 via-blue-700 to-blue-400  rounded-[50px]"
            >
              Browse Podcast
            </button>
          </div>

          <div className="relative mt-10 md:mt-0 ">
            <Image
              className="w-1/2 mx-auto md:ml-0 md:w-[375px] md:h-[504px]"
              src={logo2 ? logo2 : "/"}
              alt="logo"
            />

            <p className="text-gray-400 dark:text-blue-600 absolute -top-10 left-40 md:-top-24 md:-left-20 text-3xl md:text-8xl font-extrabold ">
              softex
            </p>

            <p className="absolute -top-10 right-6 w-8 h-8 md:w-16 md:h-16 rounded-full bg-gradient-to-br from-blue-800 to-blue-300 -z-10"></p>
          </div>
        </div>

        <div className="absolute hidden md:block  md:flex justify-between transform -translate-y-1/2 left-1 right-1 top-1/2">
          <a href="#slide1" className="cursor-pointer">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="29"
              height="50"
              viewBox="0 0 29 50"
              fill="none"
            >
              <g clipPath="url(#clip0_2_5119)">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M27.466 0.729992C26.9558 0.260997 26.279 -0.000488281 25.5754 -0.000488281C24.8717 -0.000488281 24.195 0.260997 23.6847 0.729992L1.56792 21.39C1.07285 21.8454 0.678636 22.3935 0.409262 23.001C0.139887 23.6085 0.000976563 24.2627 0.000976562 24.9237C0.000976563 25.5848 0.139887 26.239 0.409262 26.8465C0.678636 27.454 1.07285 28.0021 1.56792 28.4575L23.8449 49.27C24.878 50.2325 26.5517 50.245 27.6003 49.295C27.8542 49.0687 28.0573 48.7942 28.197 48.4888C28.3367 48.1833 28.4101 47.8532 28.4125 47.5192C28.4149 47.1851 28.3464 46.8541 28.2111 46.5468C28.0758 46.2394 27.8767 45.9622 27.6261 45.7325L7.23983 26.69C6.99209 26.4623 6.79481 26.1881 6.66 25.8843C6.52519 25.5804 6.45567 25.2532 6.45567 24.9225C6.45567 24.5918 6.52519 24.2646 6.66 23.9607C6.79481 23.6568 6.99209 23.3827 7.23983 23.155L27.4634 4.26249C27.7111 4.03499 27.9083 3.76107 28.0431 3.45742C28.1779 3.15376 28.2474 2.82673 28.2474 2.49624C28.2474 2.16575 28.1779 1.83872 28.0431 1.53506C27.9083 1.23141 27.7111 0.957492 27.4634 0.729992"
                  fill="url(#paint0_linear_2_5119)"
                />
              </g>
              <defs>
                <linearGradient
                  id="paint0_linear_2_5119"
                  x1="14.2068"
                  y1="-0.000488281"
                  x2="14.2068"
                  y2="49.9997"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#7A95CF" />
                  <stop offset="1" stopColor="#234794" />
                </linearGradient>
                <clipPath id="clip0_2_5119">
                  <rect width="28.4112" height="50" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </a>
          <a href="#slide3" className="cursor-pointer">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="29"
              height="50"
              viewBox="0 0 29 50"
              fill="none"
            >
              <g clipPath="url(#clip0_2_5117)">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M1.53406 49.2701C2.58011 50.2451 4.27187 50.2451 5.31533 49.2701L27.4321 28.6101C27.9272 28.1546 28.3214 27.6065 28.5908 26.999C28.8602 26.3916 28.9991 25.7374 28.9991 25.0763C28.9991 24.4152 28.8602 23.761 28.5908 23.1536C28.3214 22.5461 27.9272 21.998 27.4321 21.5426L5.1552 0.730051C4.64961 0.26492 3.98009 0.0034855 3.28258 -0.00115778C2.58508 -0.00580107 1.9119 0.246695 1.39975 0.705051C1.14605 0.931402 0.943048 1.20576 0.803328 1.51112C0.663607 1.81649 0.590141 2.14637 0.587477 2.48034C0.584814 2.8143 0.653011 3.14524 0.787844 3.45266C0.922677 3.76008 1.12128 4.03744 1.37134 4.26755L21.7602 23.3101C22.008 23.5378 22.2053 23.8119 22.3401 24.1158C22.4749 24.4196 22.5444 24.7469 22.5444 25.0776C22.5444 25.4082 22.4749 25.7355 22.3401 26.0393C22.2053 26.3432 22.008 26.6173 21.7602 26.8451L1.53406 45.7376C1.28639 45.9651 1.08916 46.239 0.954386 46.5426C0.819607 46.8463 0.750101 47.1733 0.750101 47.5038C0.750101 47.8343 0.819607 48.1613 0.954386 48.465C1.08916 48.7686 1.28639 49.0426 1.53406 49.2701Z"
                  fill="url(#paint0_linear_2_5117)"
                />
              </g>
              <defs>
                <linearGradient
                  id="paint0_linear_2_5117"
                  x1="14.7932"
                  y1="-0.0012207"
                  x2="14.7932"
                  y2="50.0013"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#7A95CF" />
                  <stop offset="1" stopColor="#234794" />
                </linearGradient>
                <clipPath id="clip0_2_5117">
                  <rect x="0.588867" width="28.4112" height="50" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </a>
        </div>

        <div className="absolute -bottom-10 md:bottom-16 right-14 flex gap-5 ">
          <a href="#slide1" className="w-16 h-3 border-2 border-blue-800"></a>
          <a
            href="#slide2"
            className="w-16 h-3 border-2 border-blue-800 bg-blue-800"
          ></a>
          <a href="#slide3" className="w-16 h-3 border-2 border-blue-800"></a>
          <a href="#slide4" className="w-16 h-3 border-2 border-blue-800"></a>
        </div>
      </div>

      <div
        id="slide3"
        className="carousel-item relative w-full   py-14 md:py-40 "
      >
        <div className="md:grid md:grid-cols-2 px-2 md:px-14 ">
          <div>
            <p className="text-5xl lg:text-6xl font-bold text-blue-600 pt-5 ">
              Excited to listen to the trendiest podcast out there
            </p>

            <div className="relative">
              <p className="mt-6 md:w-3/4">
                Discovered latest top-notch stories from world wide community,
                quality informative podcast and verified creators.
              </p>

              <div className="absolute z-10 right-0 md:-right-32 lg:-right-20 top-20 md:top-0 w-56 h-28  px-3 py-4 rounded-3xl bg-gray-200 filter blur-10 opacity-90">
                <p className="text-blue-600 text-base font-extrabold pb-2">
                  Enjoy The Nature
                </p>

                <svg
                  className=""
                  xmlns="http://www.w3.org/2000/svg"
                  width="192"
                  height="10"
                  viewBox="0 0 192 10"
                  fill="none"
                >
                  <rect
                    x="0.286621"
                    y="0.190308"
                    width="190.932"
                    height="9.5466"
                    rx="4.7733"
                    fill="#949494"
                  />
                  <rect
                    x="0.286621"
                    y="0.190308"
                    width="99.046"
                    height="9.5466"
                    rx="4.7733"
                    fill="#4285F4"
                  />
                </svg>

                <div className="flex justify-center gap-4 items-center mt-2">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="11"
                    height="12"
                    viewBox="0 0 11 12"
                    fill="none"
                  >
                    <path
                      d="M9.33496 4.05747V8.21913C9.33496 9.07146 8.4087 9.60635 7.66943 9.18018L5.86474 8.14085L4.06005 7.09717C3.32078 6.67101 3.32078 5.60559 4.06005 5.17942L5.86474 4.13574L7.66943 3.09642C8.4087 2.67025 9.33496 3.20078 9.33496 4.05747ZM2.16838 8.82359V3.44866V8.82359Z"
                      fill="#4285F4"
                    />
                    <path
                      d="M2.16838 8.82359V3.44866M9.33496 4.05747V8.21913C9.33496 9.07146 8.4087 9.60635 7.66943 9.18018L5.86474 8.14085L4.06005 7.09717C3.32078 6.67101 3.32078 5.60559 4.06005 5.17942L5.86474 4.13574L7.66943 3.09642C8.4087 2.67025 9.33496 3.20078 9.33496 4.05747V4.05747Z"
                      stroke="#4285F4"
                      strokeWidth="0.694541"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>

                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="27"
                    height="27"
                    viewBox="0 0 27 27"
                    fill="none"
                  >
                    <circle
                      cx="13.7125"
                      cy="13.136"
                      r="13.046"
                      fill="#4285F4"
                    />
                    <path
                      d="M9.36328 8.80995V7.00921C9.36328 4.76637 10.9598 3.84983 12.9147 4.97125L14.4895 5.87701L16.0643 6.78277C18.0192 7.90419 18.0192 9.73728 16.0643 10.8587L14.4895 11.7645L12.9147 12.6702C10.9598 13.7916 9.36328 12.8751 9.36328 10.6323V8.80995Z"
                      fill="#505050"
                    />
                  </svg>

                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="11"
                    height="12"
                    viewBox="0 0 11 12"
                    fill="none"
                  >
                    <path
                      d="M2.09131 4.05747V8.21913C2.09131 9.07146 3.01757 9.60635 3.75684 9.18018L5.56153 8.14085L7.36622 7.09717C8.10549 6.67101 8.10549 5.60559 7.36622 5.17942L5.56153 4.13574L3.75684 3.09642C3.01757 2.67025 2.09131 3.20078 2.09131 4.05747ZM9.25788 8.82359V3.44866V8.82359Z"
                      fill="#4285F4"
                    />
                    <path
                      d="M9.25789 8.82359V3.44866M2.09131 4.05747V8.21913C2.09131 9.07146 3.01757 9.60635 3.75684 9.18018L5.56153 8.14085L7.36622 7.09717C8.10549 6.67101 8.10549 5.60559 7.36622 5.17942L5.56153 4.13574L3.75684 3.09642C3.01757 2.67025 2.09131 3.20078 2.09131 4.05747V4.05747Z"
                      stroke="#4285F4"
                      strokeWidth="0.694541"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
              </div>
            </div>

            <button
              onClick={() => router.push("/podcast")}
              className="text-white text-lg font-semibold px-14 py-5 mb-10 md:mb-0 mt-36 md:mt-10 bg-gradient-to-br  from-blue-900 via-blue-700 to-blue-400  rounded-[50px]"
            >
              Browse Podcast
            </button>
          </div>

          <div className="relative mt-10 md:mt-0 ">
            <Image
              className="w-1/2 mx-auto md:ml-0 md:w-[375px] md:h-[504px]"
              src={logo3 ? logo3 : "/"}
              alt="logo"
            />

            <p className="text-gray-400 dark:text-blue-600 absolute -top-10 left-40 md:-top-24 md:left-20 text-3xl md:text-8xl font-extrabold ">
              softex
            </p>

            <p className="absolute -top-10 right-6 w-8 h-8 md:w-16 md:h-16 rounded-full bg-gradient-to-br from-blue-800 to-blue-300 -z-10"></p>
          </div>
        </div>

        <div className="absolute hidden md:block  md:flex justify-between transform -translate-y-1/2 left-1 right-1 top-1/2">
          <a href="#slide2" className="cursor-pointer">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="29"
              height="50"
              viewBox="0 0 29 50"
              fill="none"
            >
              <g clipPath="url(#clip0_2_5119)">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M27.466 0.729992C26.9558 0.260997 26.279 -0.000488281 25.5754 -0.000488281C24.8717 -0.000488281 24.195 0.260997 23.6847 0.729992L1.56792 21.39C1.07285 21.8454 0.678636 22.3935 0.409262 23.001C0.139887 23.6085 0.000976563 24.2627 0.000976562 24.9237C0.000976563 25.5848 0.139887 26.239 0.409262 26.8465C0.678636 27.454 1.07285 28.0021 1.56792 28.4575L23.8449 49.27C24.878 50.2325 26.5517 50.245 27.6003 49.295C27.8542 49.0687 28.0573 48.7942 28.197 48.4888C28.3367 48.1833 28.4101 47.8532 28.4125 47.5192C28.4149 47.1851 28.3464 46.8541 28.2111 46.5468C28.0758 46.2394 27.8767 45.9622 27.6261 45.7325L7.23983 26.69C6.99209 26.4623 6.79481 26.1881 6.66 25.8843C6.52519 25.5804 6.45567 25.2532 6.45567 24.9225C6.45567 24.5918 6.52519 24.2646 6.66 23.9607C6.79481 23.6568 6.99209 23.3827 7.23983 23.155L27.4634 4.26249C27.7111 4.03499 27.9083 3.76107 28.0431 3.45742C28.1779 3.15376 28.2474 2.82673 28.2474 2.49624C28.2474 2.16575 28.1779 1.83872 28.0431 1.53506C27.9083 1.23141 27.7111 0.957492 27.4634 0.729992"
                  fill="url(#paint0_linear_2_5119)"
                />
              </g>
              <defs>
                <linearGradient
                  id="paint0_linear_2_5119"
                  x1="14.2068"
                  y1="-0.000488281"
                  x2="14.2068"
                  y2="49.9997"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#7A95CF" />
                  <stop offset="1" stopColor="#234794" />
                </linearGradient>
                <clipPath id="clip0_2_5119">
                  <rect width="28.4112" height="50" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </a>
          <a href="#slide4" className="cursor-pointer">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="29"
              height="50"
              viewBox="0 0 29 50"
              fill="none"
            >
              <g clipPath="url(#clip0_2_5117)">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M1.53406 49.2701C2.58011 50.2451 4.27187 50.2451 5.31533 49.2701L27.4321 28.6101C27.9272 28.1546 28.3214 27.6065 28.5908 26.999C28.8602 26.3916 28.9991 25.7374 28.9991 25.0763C28.9991 24.4152 28.8602 23.761 28.5908 23.1536C28.3214 22.5461 27.9272 21.998 27.4321 21.5426L5.1552 0.730051C4.64961 0.26492 3.98009 0.0034855 3.28258 -0.00115778C2.58508 -0.00580107 1.9119 0.246695 1.39975 0.705051C1.14605 0.931402 0.943048 1.20576 0.803328 1.51112C0.663607 1.81649 0.590141 2.14637 0.587477 2.48034C0.584814 2.8143 0.653011 3.14524 0.787844 3.45266C0.922677 3.76008 1.12128 4.03744 1.37134 4.26755L21.7602 23.3101C22.008 23.5378 22.2053 23.8119 22.3401 24.1158C22.4749 24.4196 22.5444 24.7469 22.5444 25.0776C22.5444 25.4082 22.4749 25.7355 22.3401 26.0393C22.2053 26.3432 22.008 26.6173 21.7602 26.8451L1.53406 45.7376C1.28639 45.9651 1.08916 46.239 0.954386 46.5426C0.819607 46.8463 0.750101 47.1733 0.750101 47.5038C0.750101 47.8343 0.819607 48.1613 0.954386 48.465C1.08916 48.7686 1.28639 49.0426 1.53406 49.2701Z"
                  fill="url(#paint0_linear_2_5117)"
                />
              </g>
              <defs>
                <linearGradient
                  id="paint0_linear_2_5117"
                  x1="14.7932"
                  y1="-0.0012207"
                  x2="14.7932"
                  y2="50.0013"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#7A95CF" />
                  <stop offset="1" stopColor="#234794" />
                </linearGradient>
                <clipPath id="clip0_2_5117">
                  <rect x="0.588867" width="28.4112" height="50" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </a>
        </div>

        <div className="absolute -bottom-10 md:bottom-16 right-14 flex gap-5 ">
          <a href="#slide1" className="w-16 h-3 border-2 border-blue-800"></a>
          <a href="#slide2" className="w-16 h-3 border-2 border-blue-800"></a>
          <a
            href="#slide3"
            className="w-16 h-3 border-2 border-blue-800 bg-blue-800"
          ></a>
          <a href="#slide4" className="w-16 h-3 border-2 border-blue-800"></a>
        </div>
      </div>

      <div
        id="slide4"
        className="carousel-item relative w-full   py-14 md:py-40 "
      >
        <div className="md:grid md:grid-cols-2 px-2 md:px-14 ">
          <div>
            <p className="text-5xl lg:text-6xl font-bold text-blue-600 pt-5 ">
              Ready to enjoy the most popular
              <span className="flex">
                p
                <svg
                  className="mt-3 lg:mt-4"
                  xmlns="http://www.w3.org/2000/svg"
                  width="51"
                  height="51"
                  viewBox="0 0 51 51"
                  fill="none"
                >
                  <path
                    d="M40.6298 19.38C39.8011 19.38 39.1423 20.0388 39.1423 20.8675V24.225C39.1423 31.7475 33.0223 37.8675 25.4998 37.8675C17.9773 37.8675 11.8573 31.7475 11.8573 24.225V20.8463C11.8573 20.0175 11.1986 19.3588 10.3698 19.3588C9.54107 19.3588 8.88232 20.0175 8.88232 20.8463V24.2038C8.88232 32.8525 15.5336 39.9713 24.0123 40.7363V45.2625C24.0123 46.0913 24.6711 46.75 25.4998 46.75C26.3286 46.75 26.9873 46.0913 26.9873 45.2625V40.7363C35.4448 39.9925 42.1173 32.8525 42.1173 24.2038V20.8463C42.108 20.4567 41.9476 20.0859 41.6701 19.8124C41.3925 19.5388 41.0195 19.3838 40.6298 19.38Z"
                    fill="url(#paint0_linear_2_5125)"
                  />
                  <path
                    d="M25.4955 4.25C20.3105 4.25 16.103 8.4575 16.103 13.6425V24.5225C16.103 29.7075 20.3105 33.915 25.4955 33.915C30.6805 33.915 34.888 29.7075 34.888 24.5225V13.6425C34.888 8.4575 30.6805 4.25 25.4955 4.25ZM28.2793 19.0187C28.1305 19.5712 27.6418 19.9325 27.0893 19.9325C26.983 19.9325 26.8768 19.9112 26.7705 19.89C25.9418 19.6562 25.0705 19.6562 24.2418 19.89C23.5618 20.0812 22.903 19.6775 22.733 19.0187C22.5418 18.36 22.9455 17.68 23.6043 17.51C24.858 17.17 26.1755 17.17 27.4293 17.51C28.0668 17.68 28.4493 18.36 28.2793 19.0187ZM29.4055 14.8963C29.3178 15.135 29.1584 15.3408 28.9492 15.4853C28.7399 15.6299 28.4911 15.7062 28.2368 15.7037C28.088 15.7037 27.9605 15.6825 27.8118 15.64C26.3243 15.0875 24.6668 15.0875 23.1793 15.64C22.8692 15.75 22.5283 15.7336 22.2301 15.5945C21.932 15.4553 21.7005 15.2045 21.5855 14.8963C21.3518 14.2588 21.6918 13.5363 22.3293 13.3237C24.3746 12.58 26.6165 12.58 28.6618 13.3237C29.2993 13.5575 29.6393 14.2588 29.4055 14.8963Z"
                    fill="url(#paint1_linear_2_5125)"
                  />
                  <defs>
                    <linearGradient
                      id="paint0_linear_2_5125"
                      x1="5.84643"
                      y1="23.6196"
                      x2="51.2982"
                      y2="29.673"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stopColor="#FF9447" />
                      <stop offset="0.358383" stopColor="#FF64C1" />
                      <stop offset="0.65524" stopColor="#925EFF" />
                      <stop offset="1" stopColor="#1A1EFF" />
                    </linearGradient>
                    <linearGradient
                      id="paint1_linear_2_5125"
                      x1="14.3871"
                      y1="8.86456"
                      x2="40.4072"
                      y2="10.6731"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stopColor="#FF9447" />
                      <stop offset="0.358383" stopColor="#FF64C1" />
                      <stop offset="0.65524" stopColor="#925EFF" />
                      <stop offset="1" stopColor="#1A1EFF" />
                    </linearGradient>
                  </defs>
                </svg>
                dcast
              </span>
            </p>

            <div className="relative">
              <p className="mt-6 md:w-3/4">
                Discovered latest top-notch stories from world wide community,
                quality informative podcast and verified creators.
              </p>

              <div className="absolute z-10 right-0 md:-right-32 lg:-right-20 top-20 md:top-0 w-56 h-28  px-3 py-4 rounded-3xl bg-gray-200 filter blur-10 opacity-90">
                <p className="text-blue-600 text-base font-extrabold pb-2">
                  Enjoy The Nature
                </p>

                <svg
                  className=""
                  xmlns="http://www.w3.org/2000/svg"
                  width="192"
                  height="10"
                  viewBox="0 0 192 10"
                  fill="none"
                >
                  <rect
                    x="0.286621"
                    y="0.190308"
                    width="190.932"
                    height="9.5466"
                    rx="4.7733"
                    fill="#949494"
                  />
                  <rect
                    x="0.286621"
                    y="0.190308"
                    width="99.046"
                    height="9.5466"
                    rx="4.7733"
                    fill="#4285F4"
                  />
                </svg>

                <div className="flex justify-center gap-4 items-center mt-2">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="11"
                    height="12"
                    viewBox="0 0 11 12"
                    fill="none"
                  >
                    <path
                      d="M9.33496 4.05747V8.21913C9.33496 9.07146 8.4087 9.60635 7.66943 9.18018L5.86474 8.14085L4.06005 7.09717C3.32078 6.67101 3.32078 5.60559 4.06005 5.17942L5.86474 4.13574L7.66943 3.09642C8.4087 2.67025 9.33496 3.20078 9.33496 4.05747ZM2.16838 8.82359V3.44866V8.82359Z"
                      fill="#4285F4"
                    />
                    <path
                      d="M2.16838 8.82359V3.44866M9.33496 4.05747V8.21913C9.33496 9.07146 8.4087 9.60635 7.66943 9.18018L5.86474 8.14085L4.06005 7.09717C3.32078 6.67101 3.32078 5.60559 4.06005 5.17942L5.86474 4.13574L7.66943 3.09642C8.4087 2.67025 9.33496 3.20078 9.33496 4.05747V4.05747Z"
                      stroke="#4285F4"
                      strokeWidth="0.694541"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>

                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="27"
                    height="27"
                    viewBox="0 0 27 27"
                    fill="none"
                  >
                    <circle
                      cx="13.7125"
                      cy="13.136"
                      r="13.046"
                      fill="#4285F4"
                    />
                    <path
                      d="M9.36328 8.80995V7.00921C9.36328 4.76637 10.9598 3.84983 12.9147 4.97125L14.4895 5.87701L16.0643 6.78277C18.0192 7.90419 18.0192 9.73728 16.0643 10.8587L14.4895 11.7645L12.9147 12.6702C10.9598 13.7916 9.36328 12.8751 9.36328 10.6323V8.80995Z"
                      fill="#505050"
                    />
                  </svg>

                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="11"
                    height="12"
                    viewBox="0 0 11 12"
                    fill="none"
                  >
                    <path
                      d="M2.09131 4.05747V8.21913C2.09131 9.07146 3.01757 9.60635 3.75684 9.18018L5.56153 8.14085L7.36622 7.09717C8.10549 6.67101 8.10549 5.60559 7.36622 5.17942L5.56153 4.13574L3.75684 3.09642C3.01757 2.67025 2.09131 3.20078 2.09131 4.05747ZM9.25788 8.82359V3.44866V8.82359Z"
                      fill="#4285F4"
                    />
                    <path
                      d="M9.25789 8.82359V3.44866M2.09131 4.05747V8.21913C2.09131 9.07146 3.01757 9.60635 3.75684 9.18018L5.56153 8.14085L7.36622 7.09717C8.10549 6.67101 8.10549 5.60559 7.36622 5.17942L5.56153 4.13574L3.75684 3.09642C3.01757 2.67025 2.09131 3.20078 2.09131 4.05747V4.05747Z"
                      stroke="#4285F4"
                      strokeWidth="0.694541"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
              </div>
            </div>

            <button
              onClick={() => router.push("/podcast")}
              className="text-white text-lg font-semibold px-14 py-5 mb-10 md:mb-0 mt-36 md:mt-10 bg-gradient-to-br  from-blue-900 via-blue-700 to-blue-400  rounded-[50px]"
            >
              Browse Podcast
            </button>
          </div>

          <div className="relative mt-10 md:mt-0 ">
            <Image
              className="w-1/2 mx-auto md:ml-0 md:w-[375px] md:h-[504px]"
              src={logo ? logo : "/"}
              alt="logo"
            />

            <div className="absolute top-2 md:-top-10 md:-left-32 w-[83px] h-8 md:w-44 md:h-[70px] bg-blue-700 rounded-[141px]">
              <div className="flex items-center ml-2">
                <Image
                  className="w-1/3 md:w-[55px] py-1 md:py-[7px]"
                  src={pic1 ? pic1 : "/"}
                  alt="logo"
                />
                <Image
                  className="w-1/3 md:w-[55px] py-1 md:py-[7px] absolute left-7 md:left-10"
                  src={pic2 ? pic2 : "/"}
                  alt="logo"
                />

                <div className="absolute hidden md:block right-2 bg-black p-3 rounded-full">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="35"
                    height="35"
                    viewBox="0 0 35 35"
                    fill="none"
                  >
                    <path
                      d="M34.0243 15.1178L31.6876 12.4234C31.2409 11.9118 30.8801 10.9568 30.8801 10.2747V7.37572C30.8801 5.56811 29.3853 4.08451 27.5641 4.08451H24.6433C23.9732 4.08451 22.9939 3.7264 22.4785 3.28302L19.7638 0.963821C18.5783 -0.0423022 16.6368 -0.0423022 15.4341 0.963821L12.7367 3.30007C12.2212 3.7264 11.2419 4.08451 10.5718 4.08451H7.59946C5.77824 4.08451 4.28347 5.56811 4.28347 7.37572V10.2918C4.28347 10.9568 3.92266 11.9118 3.49313 12.4234L1.17366 15.1348C0.177141 16.3115 0.177141 18.2214 1.17366 19.398L3.49313 22.1095C3.92266 22.621 4.28347 23.576 4.28347 24.2411V27.1571C4.28347 28.9647 5.77824 30.4483 7.59946 30.4483H10.5718C11.2419 30.4483 12.2212 30.8065 12.7367 31.2498L15.4513 33.569C16.6368 34.5752 18.5783 34.5752 19.781 33.569L22.4956 31.2498C23.0111 30.8065 23.9732 30.4483 24.6605 30.4483H27.5813C29.4025 30.4483 30.8973 28.9647 30.8973 27.1571V24.2581C30.8973 23.5931 31.2581 22.621 31.7048 22.1095L34.0415 19.4151C35.038 18.2384 35.038 16.2944 34.0243 15.1178ZM24.7464 14.0434L16.4478 22.28C16.2062 22.5195 15.8787 22.654 15.5372 22.654C15.1957 22.654 14.8682 22.5195 14.6266 22.28L10.4687 18.1532C10.2291 17.9125 10.0947 17.5878 10.0947 17.2494C10.0947 16.911 10.2291 16.5862 10.4687 16.3456C10.967 15.851 11.7917 15.851 12.29 16.3456L15.5372 19.5686L22.9252 12.2358C23.4234 11.7413 24.2481 11.7413 24.7464 12.2358C25.2446 12.7303 25.2446 13.5489 24.7464 14.0434Z"
                      fill="#4285F4"
                    />
                  </svg>
                </div>
              </div>
            </div>

            <p className="text-gray-400 dark:text-blue-600 absolute -top-10 left-40 md:-top-24 md:left-20 text-3xl md:text-8xl font-extrabold ">
              softex
            </p>

            <p className="absolute -top-10 right-6 w-8 h-8 md:w-16 md:h-16 rounded-full bg-gradient-to-br from-blue-800 to-blue-300 -z-10"></p>

            <svg
              className="absolute top-28 md:-right-10 lg:right-20"
              xmlns="http://www.w3.org/2000/svg"
              width="221"
              height="94"
              viewBox="0 0 221 94"
              fill="none"
            >
              <g filter="url(#filter0_b_2_6004)">
                <rect
                  x="0.554688"
                  y="0.979492"
                  width="219.815"
                  height="92.7543"
                  rx="12.7061"
                  fill="#838383"
                  fillOpacity="0.2"
                />
              </g>
              <line
                opacity="0.5"
                x1="10.084"
                y1="46.086"
                x2="209.569"
                y2="46.086"
                stroke="#ADADAD"
                strokeWidth="1.27061"
                strokeLinecap="round"
              />
              <defs>
                <filter
                  id="filter0_b_2_6004"
                  x="-50.2696"
                  y="-49.8448"
                  width="321.464"
                  height="194.403"
                  filterUnits="userSpaceOnUse"
                  colorInterpolationFilters="sRGB"
                >
                  <feFlood floodOpacity="0" result="BackgroundImageFix" />
                  <feGaussianBlur
                    in="BackgroundImageFix"
                    stdDeviation="25.4121"
                  />
                  <feComposite
                    in2="SourceAlpha"
                    operator="in"
                    result="effect1_backgroundBlur_2_6004"
                  />
                  <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_backgroundBlur_2_6004"
                    result="shape"
                  />
                </filter>
              </defs>
            </svg>

            <svg
              className="absolute top-[100px] left-[310px] md:-right-2 lg:left-[435px] z-40"
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M7.70096 1.99658H5.82148C4.78726 1.99658 3.85249 2.41425 3.16633 3.10041C2.48016 3.78657 2.0625 4.72134 2.0625 5.75556C2.0625 7.82399 3.75304 9.51454 5.82148 9.51454H6.75625V17.0225C6.75625 17.7485 7.17391 18.375 7.78052 18.6833C8.00668 18.8081 8.25752 18.8817 8.51528 18.8989C8.77305 18.9161 9.03144 18.8764 9.27217 18.7827C9.99811 18.5241 10.5152 17.838 10.5152 17.0225V4.81084C10.5152 3.26946 9.24234 1.99658 7.70096 1.99658ZM5.82148 5.9445C6.22919 5.9445 6.5673 6.28261 6.5673 6.69033C6.5673 7.09805 6.22919 7.43616 5.82148 7.43616C4.89665 7.43616 4.14088 6.68039 4.14088 5.74562C4.14088 4.81084 4.89665 4.06502 5.82148 4.06502C6.22919 4.06502 6.5673 4.40312 6.5673 4.81084C6.5673 5.21856 6.22919 5.55667 5.82148 5.55667C5.77136 5.55667 5.72331 5.57658 5.68787 5.61201C5.65244 5.64745 5.63253 5.6955 5.63253 5.74562C5.63253 5.84506 5.71209 5.9445 5.82148 5.9445ZM20.8474 3.10041C20.4997 2.75012 20.0861 2.47222 19.6303 2.28275C19.1746 2.09329 18.6858 1.99603 18.1923 1.99658H16.3128C15.5672 1.99921 14.8529 2.29655 14.3257 2.82376C13.7985 3.35097 13.5012 4.06526 13.4985 4.81084V17.0225C13.4985 17.838 14.0156 18.5241 14.7416 18.7827C14.9823 18.8764 15.2407 18.9161 15.4985 18.8989C15.7562 18.8817 16.0071 18.8081 16.2332 18.6833C16.8398 18.375 17.2575 17.7485 17.2575 17.0225V9.51454H18.1923C20.2607 9.51454 21.9513 7.82399 21.9513 5.75556C21.9513 4.72134 21.5336 3.78657 20.8474 3.10041ZM18.1923 7.43616C17.7846 7.43616 17.4465 7.09805 17.4465 6.69033C17.4465 6.28261 17.7846 5.9445 18.1923 5.9445C18.3017 5.9445 18.3812 5.855 18.3812 5.74562C18.3812 5.6955 18.3613 5.64745 18.3259 5.61201C18.2905 5.57658 18.2424 5.55667 18.1923 5.55667C17.7846 5.55667 17.4465 5.21856 17.4465 4.81084C17.4465 4.40312 17.7846 4.06502 18.1923 4.06502C18.6393 4.06502 19.0681 4.2426 19.3842 4.55871C19.7003 4.87481 19.8779 5.30355 19.8779 5.75059C19.8779 6.19763 19.7003 6.62636 19.3842 6.94247C19.0681 7.25857 18.6393 7.43616 18.1923 7.43616Z"
                fill="white"
              />
              <path
                d="M9.27193 18.7836V21.8863C9.27193 22.294 8.93382 22.6321 8.5261 22.6321C8.11838 22.6321 7.78027 22.294 7.78027 21.8863V18.6842C8.00642 18.8091 8.25726 18.8828 8.51503 18.9C8.77281 18.9171 9.03121 18.8774 9.27193 18.7836ZM16.233 18.6842V21.8863C16.233 22.294 15.8949 22.6321 15.4872 22.6321C15.0794 22.6321 14.7413 22.294 14.7413 21.8863V18.7836C14.9821 18.8774 15.2405 18.9171 15.4982 18.9C15.756 18.8828 16.0069 18.8091 16.233 18.6842Z"
                fill="white"
              />
            </svg>

            <svg
              className="absolute top-24 md:-right-5 lg:right-28"
              xmlns="http://www.w3.org/2000/svg"
              width="175"
              height="83"
              viewBox="0 0 175 83"
              fill="none"
            >
              <ellipse
                cx="7.8079"
                cy="37.4903"
                rx="7.15995"
                ry="7.10868"
                fill="#4285F4"
              />
              <rect
                x="20.9346"
                y="32.7512"
                width="45.3464"
                height="3.55434"
                rx="1.77717"
                fill="#4285F4"
              />
              <rect
                x="20.9346"
                y="39.8597"
                width="82.3395"
                height="3.55434"
                rx="1.77717"
                fill="#4285F4"
              />
              <rect
                x="134.3"
                y="0.762085"
                width="33.4131"
                height="31.9891"
                rx="6.35303"
                fill="#4285F4"
              />
              <rect
                x="22.1279"
                y="80.1423"
                width="152.746"
                height="2.36956"
                rx="1.18478"
                fill="#7E7E7E"
              />
              <rect
                x="22.1279"
                y="80.1423"
                width="45.3464"
                height="2.36956"
                rx="1.18478"
                fill="#4285F4"
              />
            </svg>

            <div className="absolute bottom-1 md:bottom-16 lg:-bottom-5 right-10 md:right-20 w-[93px] h-[33px] md:w-[195px] md:h-[74px] bg-blue-700 rounded-[141px]">
              <div className="flex items-center gap-2 md:gap-3 ml-1 md:ml-2">
                <Image
                  className="w-1/3 md:w-[58px] py-[2px] md:py-[7px]"
                  src={pic3 ? pic3 : "/"}
                  alt="logo"
                />

                <div>
                  <p className="w-[43px] h-[4px] md:w-[90px]  md:h-[10px] rounded-[28px] bg-white"></p>
                  <p className="w-[27px] h-[3px] md:w-[58px]  md:h-[7px] rounded-[28px] mt-2 bg-gray-400"></p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="absolute hidden md:block  md:flex justify-between transform -translate-y-1/2 left-1 right-1 top-1/2">
          <a href="#slide3" className="cursor-pointer">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="29"
              height="50"
              viewBox="0 0 29 50"
              fill="none"
            >
              <g clipPath="url(#clip0_2_5119)">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M27.466 0.729992C26.9558 0.260997 26.279 -0.000488281 25.5754 -0.000488281C24.8717 -0.000488281 24.195 0.260997 23.6847 0.729992L1.56792 21.39C1.07285 21.8454 0.678636 22.3935 0.409262 23.001C0.139887 23.6085 0.000976563 24.2627 0.000976562 24.9237C0.000976563 25.5848 0.139887 26.239 0.409262 26.8465C0.678636 27.454 1.07285 28.0021 1.56792 28.4575L23.8449 49.27C24.878 50.2325 26.5517 50.245 27.6003 49.295C27.8542 49.0687 28.0573 48.7942 28.197 48.4888C28.3367 48.1833 28.4101 47.8532 28.4125 47.5192C28.4149 47.1851 28.3464 46.8541 28.2111 46.5468C28.0758 46.2394 27.8767 45.9622 27.6261 45.7325L7.23983 26.69C6.99209 26.4623 6.79481 26.1881 6.66 25.8843C6.52519 25.5804 6.45567 25.2532 6.45567 24.9225C6.45567 24.5918 6.52519 24.2646 6.66 23.9607C6.79481 23.6568 6.99209 23.3827 7.23983 23.155L27.4634 4.26249C27.7111 4.03499 27.9083 3.76107 28.0431 3.45742C28.1779 3.15376 28.2474 2.82673 28.2474 2.49624C28.2474 2.16575 28.1779 1.83872 28.0431 1.53506C27.9083 1.23141 27.7111 0.957492 27.4634 0.729992"
                  fill="url(#paint0_linear_2_5119)"
                />
              </g>
              <defs>
                <linearGradient
                  id="paint0_linear_2_5119"
                  x1="14.2068"
                  y1="-0.000488281"
                  x2="14.2068"
                  y2="49.9997"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#7A95CF" />
                  <stop offset="1" stopColor="#234794" />
                </linearGradient>
                <clipPath id="clip0_2_5119">
                  <rect width="28.4112" height="50" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </a>
          <a href="#slide1" className="cursor-pointer">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="29"
              height="50"
              viewBox="0 0 29 50"
              fill="none"
            >
              <g clipPath="url(#clip0_2_5117)">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M1.53406 49.2701C2.58011 50.2451 4.27187 50.2451 5.31533 49.2701L27.4321 28.6101C27.9272 28.1546 28.3214 27.6065 28.5908 26.999C28.8602 26.3916 28.9991 25.7374 28.9991 25.0763C28.9991 24.4152 28.8602 23.761 28.5908 23.1536C28.3214 22.5461 27.9272 21.998 27.4321 21.5426L5.1552 0.730051C4.64961 0.26492 3.98009 0.0034855 3.28258 -0.00115778C2.58508 -0.00580107 1.9119 0.246695 1.39975 0.705051C1.14605 0.931402 0.943048 1.20576 0.803328 1.51112C0.663607 1.81649 0.590141 2.14637 0.587477 2.48034C0.584814 2.8143 0.653011 3.14524 0.787844 3.45266C0.922677 3.76008 1.12128 4.03744 1.37134 4.26755L21.7602 23.3101C22.008 23.5378 22.2053 23.8119 22.3401 24.1158C22.4749 24.4196 22.5444 24.7469 22.5444 25.0776C22.5444 25.4082 22.4749 25.7355 22.3401 26.0393C22.2053 26.3432 22.008 26.6173 21.7602 26.8451L1.53406 45.7376C1.28639 45.9651 1.08916 46.239 0.954386 46.5426C0.819607 46.8463 0.750101 47.1733 0.750101 47.5038C0.750101 47.8343 0.819607 48.1613 0.954386 48.465C1.08916 48.7686 1.28639 49.0426 1.53406 49.2701Z"
                  fill="url(#paint0_linear_2_5117)"
                />
              </g>
              <defs>
                <linearGradient
                  id="paint0_linear_2_5117"
                  x1="14.7932"
                  y1="-0.0012207"
                  x2="14.7932"
                  y2="50.0013"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#7A95CF" />
                  <stop offset="1" stopColor="#234794" />
                </linearGradient>
                <clipPath id="clip0_2_5117">
                  <rect x="0.588867" width="28.4112" height="50" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </a>
        </div>

        <div className="absolute -bottom-10 md:bottom-16 right-14 flex gap-5 ">
          <a href="#slide1" className="w-16 h-3 border-2 border-blue-800"></a>
          <a href="#slide2" className="w-16 h-3 border-2 border-blue-800"></a>
          <a href="#slide3" className="w-16 h-3 border-2 border-blue-800"></a>
          <a
            href="#slide4"
            className="w-16 h-3 border-2 border-blue-800 bg-blue-800"
          ></a>
        </div>
      </div>
    </div>
  );
};

export default CarouselOne;
